import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatTable } from "@angular/material/table";
import { MatDialog } from "@angular/material/dialog";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import { Report } from '../../../../admin/report/report';
import { Balance } from '../../../seller';
import { PasswordConfirmComponent } from "../../../../../shared/components/password-confirm/password-confirm.component";
import { FormValidatorService } from "../../../../../shared/services/form-validator.service";
import { TitledModalWithContentService } from "../../../../../shared/services/titled-modal-with-content.service";
import { Validators } from "../../../../../shared/validators";
import { AlertDialogComponent } from "../../../../../shared/components/alert-dialog/alert-dialog.component";
import { ListBankAccountsService } from "../../services/list-accounts.service";
import { ConvertBalanceToAvailableService } from "../../services/convert-balance.service";
import { WithdrawRequestService } from "../../services/withdraw-request.service";
import { WithdrawalsReportService } from "../../services/withdrawals-report.service";
import { FetchSellerBalanceService } from "../../services/fetch-seller-balance.service";
import Swal from "sweetalert2";
import { LanguageService } from "../../../../../shared/services/language.service";
import { RecurringWithdrawService } from "../../services/recurring-withdrawal.service";
import { CancelRecurringWithdrawService } from "../../services/cancel-recurring-withdrawal.service";
import { AuthService } from "src/app/shared/services/auth.service";
import { TwoFactorAuthOtpService } from "src/app/shared/services/two-factor-auth/two.factor.auth.service";

@Component({
  selector: 'app-withdrawals',
  templateUrl: './withdrawals.component.html',
  styleUrls: ['./withdrawals.component.scss'],
})
export class WithdrawalsComponent implements OnInit, OnDestroy, AfterViewInit {
  balanceObject = {} as Balance;
  withdrawalsReportData: any;
  tableId: string = 'tableId';
  searchKey: string = '';
  loading: boolean = false;
  isDisabled: boolean = false;

  // Bank Account table data source
  @ViewChild(MatTable) table!: MatTable<any>;
  displayedColumns: string[] = [
    'amount',
    'type',
    'accountType',
    'status',
    'bank',
    'date',
  ];
  displayTableColumns = {};
  dataSource: any[] = [];
  rowsLength: any;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  formValidator = new FormValidatorService();
  withdrawForm!: FormGroup;
  recurringWithdrawForm!: FormGroup;

  accounts: any; // bank accounts
  requestBody: Report = {};
  numberOfPages: any;
  totalNumberOfRecords: number = 0;
  withdrwalReportData: any[] = [];
  pattern: string = '^[0-9]*$';
  availableFeesPercentage: any;
  businessObject!: { [x: string]: any; contractStatus: string };
  reportName: string = '';
  isRecurringActive: boolean = false;

  constructor(
    private fetchBalanceService: FetchSellerBalanceService,
    public withdrawalsReportService: WithdrawalsReportService,
    private withdrawRequestService: WithdrawRequestService,
    private recurringWithdrawService: RecurringWithdrawService,
    private cancelRecurringWithdrawService: CancelRecurringWithdrawService,
    private authService: AuthService,
    private listBankAccountService: ListBankAccountsService,
    private titleModalService: TitledModalWithContentService,
    public dialog: MatDialog,
    private convertBalanceToAvailableService: ConvertBalanceToAvailableService,
    private snackbar: MatSnackBar,
    private translate: TranslateService,
    private languageService: LanguageService,
    private twoFactorAuthOtpService: TwoFactorAuthOtpService
  ) {}

  async ngOnInit() {
    if (localStorage.getItem('language')) {
      if (localStorage.getItem('language') === 'ar') {
        this.loadArContent();
      } else if (localStorage.getItem('language') === 'en') {
        this.loadEnContent();
      }
    } else {
      this.loadEnContent();
    }
    this.languageService.languageUpdated.subscribe((lang: string) => {
      if (lang === 'ar') {
        this.loadArContent();
      } else if (lang === 'en') {
        this.loadEnContent();
      }
    });
    this.withdrawalsReportService.activateLoader();
    this.businessObject = await this.authService.getBusiness();
    this.isRecurringActive = this.businessObject.RecurringWithdrawal !== 'none';
    this.availableFeesPercentage =
      this.businessObject['availableFeesPercentage'];
    this.balanceObject = await this.fetchBalanceService.make();
    localStorage.removeItem('p');

    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10,
    };
    this.updateTable();
    let accountsData = await this.listBankAccountService.make();
    this.accounts = accountsData.result;
    this.balanceObject = await this.fetchBalanceService.make();

    this.withdrawForm = this.formValidator.createForm([
      {
        fieldName: 'account_number',
        defaultValue: null,
        validators:
          this.isDisabled == false
            ? [
                {
                  validatorFn: Validators.required,
                  message: '',
                },
              ]
            : [],
      },
      {
        fieldName: 'withdrwal_type',
        defaultValue: null,
        validators:
          this.isDisabled == false
            ? [
                {
                  validatorFn: Validators.required,
                  message: '',
                },
              ]
            : [],
      },
      {
        fieldName: 'required_amount',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
          {
            validatorFn: Validators.max(this.balanceObject.avalibleBalance),
            message: '',
          },
          {
            validatorFn: Validators.min(500),
            message: '',
          },
        ],
      },
    ]);
    this.recurringWithdrawForm = this.formValidator.createForm([
      {
        fieldName: 'account_number',
        defaultValue: null,
        validators:
          this.isDisabled == false
            ? [
                {
                  validatorFn: Validators.required,
                  message: '',
                },
              ]
            : [],
      },
      {
        fieldName: 'recurring_day',
        defaultValue: null,
        validators:
          this.isDisabled == false
            ? [
                {
                  validatorFn: Validators.required,
                  message: '',
                },
              ]
            : [],
      },
    ]);
    this.translateValidationMessages();

    this.updateTable();
    this.withdrawalsReportService
      .loader()
      .subscribe((val: any) => (this.loading = val));
  }

  ngAfterViewInit() {
    this.translateValidationMessages();
    this.translate.onLangChange.subscribe(() => {
      this.translateValidationMessages();
    });
  }

  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {
      this.formValidator.validationMessages = {
        account_number: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Bank Account Number',
            fieldAr: 'رقم الحساب المصرفي',
          }),
        },
        withdrwal_type: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Withdrawal Type',
            fieldAr: 'نوع عملية السحب',
          }),
        },
        recurring_day: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Recurring Day',
            fieldAr: 'يوم التكرار',
          }),
        },
        required_amount: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Withdraw Amount',
            fieldAr: 'مبلغ السحب',
          }),
          max: this.translate.instant('FormValidation.Max', {
            field: 'Withdraw Amount',
            fieldAr: 'مبلغ السحب',
            value: this.balanceObject.avalibleBalance,
          }),
          min: this.translate.instant('FormValidation.Min', {
            field: 'Withdraw Amount',
            fieldAr: 'مبلغ السحب',
            value: '500 EGP',
          }),
        },
      };
    });
  }

  loadArContent() {
    this.reportName = ' تقرير عمليات السحب ';
    this.translate.use('ar');

    this.displayTableColumns = {
      amount: 'المبلغ',
      type: 'نوع عملية السحب',
      accountType: 'نوع الحساب',
      status: 'الحالة',
      bank: 'البنك',
      date: 'التاريخ',
    };
  }

  loadEnContent() {
    this.reportName = 'Withdrawals Report';
    this.translate.use('en');

    this.displayTableColumns = {
      amount: 'amount',
      type: 'Withdraw Type',
      accountType: 'Account Type',
      status: 'status',
      bank: 'bank',
      date: 'date',
    };
  }

  ngOnDestroy() {
    localStorage.removeItem('p');
  }

  print() {
    const headerEl = document.createElement('h1');
    headerEl.innerText = 'PayME Store - Your Online Payment Gateway';
    const divToPrint = <HTMLDivElement>document.getElementById(this.tableId);
    divToPrint.insertAdjacentElement('afterbegin', headerEl);
    const newWin = window.open('');
    newWin?.document.write(divToPrint.outerHTML);
    newWin?.print();
    newWin?.close();
    divToPrint.removeChild(headerEl);
  }

  async onSubmit() {
    try {
      const result = await this.openPassword();
      if (!result?.status) {
        return;
      } else {
        let allowed = this.checkBusinessStatus();
        if (!allowed) return;
        const withdrawalParams = {
          amount: this.withdrawForm.value.required_amount,
          BankAccountId: this.withdrawForm.value.account_number,
          withdrawalType: this.withdrawForm.value.withdrwal_type,
          otpCode: result.otp ?? null,
        };

        this.withdrawRequestService.setParams(withdrawalParams);
        const withdraw = await this.withdrawRequestService.make();
        if (withdraw) {
          this.balanceObject = await this.fetchBalanceService.make();
          this.withdrawForm.reset();
          this.toastSuccessMessage();
        }
      }

      this.withdrawalsReportData = await this.withdrawalsReportService.make();
      this.dataSource = this.withdrawalsReportData['report'];
      this.numberOfPages = this.withdrawalsReportData['numOfPages'];
    } catch (err) {
      this.handleErrors(err);
    }
  }
  async onRecurringSubmit() {
    const passwordResult = await this.openPassword();
    try {
      if (!passwordResult?.status) {
        return;
      } else {
        let allowed = this.checkBusinessStatus();
        if (!allowed) return;
        const recurringWithdrawalParams = {
          BankAccountId: this.recurringWithdrawForm.value.account_number,
          recurringDay: this.recurringWithdrawForm.value.recurring_day,
          otpCode: passwordResult.otp ?? null,
        };
        this.recurringWithdrawService.setParams(recurringWithdrawalParams);
        let result = await this.recurringWithdrawService.make();
        if (result.success) {
          this.updateBusiness(result.recurringValue);
          this.subscribedNotifier();
        }
      }
    } catch (err) {
      this.twoFactorAuthOtpService.handleErrors(err);
    }
  }
  async onRecurringCancel() {
    const passwordResult = await this.openPassword();
    try {
      if (!passwordResult?.status) {
        return;
      } else {
        this.cancelRecurringWithdrawService.setParams({
          otpCode: passwordResult.otp ?? null,
        });
        let result = await this.cancelRecurringWithdrawService.make();
        if (result.success) {
          this.updateBusiness(result.recurringValue);
          this.unSubscribedNotifier();
        }
      }
    } catch (error) {
      this.twoFactorAuthOtpService.handleErrors(error);
    }
  }
  async openPassword() {
    await this.twoFactorAuthOtpService.sendOtp('withdrawals');
    const dialogRef = this.dialog.open(PasswordConfirmComponent, {
      data: {
        operation: 'withdrawals',
      },
    });
    const result = await dialogRef.afterClosed().toPromise();
    console.log('result ', result);
    return result;
  }
  updateBusiness(recurringValue) {
    this.isRecurringActive = recurringValue !== 'none';
    this.businessObject.isRecurringActive = recurringValue;
    this.authService.setBusiness(this.businessObject);
  }
  checkBusinessStatus() {
    if (
      this.businessObject.contractStatus != 'signed' &&
      !this.businessObject.can_withdraw
    ) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: `You are not allowed to withdraw, Please sign the contract first`,
      });
      return false;
    }
    return true;
  }
  subscribedNotifier() {
    Swal.fire({
      icon: 'success',
      title: this.translate.instant('Sellers.Products.Subscribe'),
      showConfirmButton: false,
      timer: 1500,
    });
  }
  unSubscribedNotifier() {
    Swal.fire({
      icon: 'success',
      title: this.translate.instant('Sellers.Products.UnSubscribe'),
      showConfirmButton: false,
      timer: 1500,
    });
  }
  async paginate($event: any) {
    this.requestBody.paginationOptions = {
      start: $event.pageIndex * $event.pageSize,
      limit: $event.pageSize,
    };
    this.updateTable();
    this.withdrawalsReportService
      .loader()
      .subscribe((val: any) => (this.loading = val));
  }

  async searchChange($event: any) {
    if ($event) {
      this.requestBody.searchOptions = {
        searchKey: $event,
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.withdrawalsReportService
        .loader()
        .subscribe((val: any) => (this.loading = val));
    }
    await this.updateTable();
  }

  async sortChange(event: any) {
    if (event.direction === '') {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction,
      };
    }
    await this.updateTable();
    this.withdrawalsReportService
      .loader()
      .subscribe((val: any) => (this.loading = val));
  }

  async filter($event: any) {
    console.log('object is', $event);
    if ($event && Object.keys($event).length) {
      console.log('filter should not be null');
      this.requestBody.filterOptions = $event;
    } else {
      console.log('filter should be null');
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10,
    };
    this.updateTable();
    this.withdrawalsReportService
      .loader()
      .subscribe((val: any) => (this.loading = val));
  }

  async updateTable() {
    this.withdrawalsReportService.activateLoader();
    await this.withdrawalsReportService.setParams(this.requestBody);
    const report = await this.withdrawalsReportService.make();
    this.withdrwalReportData = report.result;
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }

  async convertPendingToAvailableFees() {
    try {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        data: {
          message: this.translate.instant(
            'Sellers.Products.ConfirmConvertAmount',
            {
              field: this.balanceObject.pendingBalance,
              percentage: this.availableFeesPercentage,
            }
          ),
          question: true,
        },
      });
      const result = await dialogRef.afterClosed().toPromise();
      if (!result) {
        return;
      }
      this.convertBalanceToAvailableService.setParams({});
      await this.convertBalanceToAvailableService.make();
      this.snackbar.open(
        this.translate.instant('Sellers.Products.PendingConvertedToAvailable'),
        '',
        { duration: 3000 }
      );
      this.balanceObject = await this.fetchBalanceService.make();
    } catch (error) {
      console.log(error);
    }
  }

  handleErrors(err: any) {
    if (this.twoFactorAuthOtpService.isOtpException(err)) {
      this.twoFactorAuthOtpService.handleErrors(err);
      return;
    }
    const title = 'An Error Occurred';
    if (err.faultyRequest.error.name === 'CannotWithDrawException') {
      this.titleModalService.open({
        title,
        content: 'Your business can not withdraw.',
        closeButtonName: 'Close',
      });
    } else {
      this.titleModalService.open({
        title,
        content: err.faultyRequest.error.message,
        closeButtonName: 'Close',
      })
    }
  }

  private async toastSuccessMessage(): Promise<void> {
    const currentLanguage = localStorage.getItem('language');
    let title = 'The operation was completed successfully!';

    if (currentLanguage === 'ar') {
      title = 'تمت العملية بنجاح';
    }

    await Swal.fire({
      icon: 'success',
      title,
      showConfirmButton: false,
      timer: 1500
    });
  }
}
